/* global angular */

angular
.module('gc.ng-repeat-done', [])
.directive('ngRepeatDone', ['$timeout', function($timeout) {
  'use strict';
  return {
    link: function(scope, element, attrs) {
      if (scope.$last) {
        $timeout(function () {
          scope.$eval(attrs.ngRepeatDone)
        });
      }
    }
  };
}]);
